import api from 'Api'
import { SET_MESSAGE } from '../components/utils'
import router from '../router/index'
import { addMissingBins, sortArrayWithString } from '../utils/main_helper'
const moment = require('moment')

const URL = '/discovery/get-discovery-list'
const URL_ANALYSIS = '/discovery/data-discovery-analysis'
const URL_TIME_SERIES = '/discovery/discovery-time-series'
const URL_COMPARISON = '/discovery/data-discovery-comparison-analysis'
const labels2 = ['< 1', '1 - 2', '2 - 3', '3 - 4', '4 - 5', '5 - 6', '6 - 7', '7 - 8', '8 - 9', '9 - 10', '> 10']
const sizes = [' < 100KB', '100KB - 500KB', '500KB - 1MB', '1MB - 10MB', '10MB - 100MB', '100MB - 1GB', '> 1GB']
const newSizes = [' < 10KB', '10KB - 100KB', '100KB - 1MB', '1MB - 10MB', '10MB - 100MB', '100MB - 1GB', '> 1GB']
const ageBins = ['< 1yr old', '>= 1 and < 2 yrs', '>= 2 and < 3 yrs', '>= 3 and < 4 yrs', '>= 4 and < 5 yrs', '>= 5 and < 6 yrs', '>= 6 and < 7 yrs', '>= 7 and < 8 yrs', '>= 8 and < 9 yrs', '>= 9 and < 10 yrs', '>= 10yrs']

const state = {
  isLoadingScans: true,
  isLoadingAnalysis: false,
  isLoadingComparison: false,
  labelIndexs: {
    size: {},
    age: []
  },
  size: [],
  last_modified: [],
  extension: [],
  scanList: [],
  sizeFilters: [],
  lastModifiedFilters: [],
  extensionFilters: [],
  comparisonList: null,
  discoveryId: '',
  selectedAge: null,
  selectedSize: null,
  selectedFileExtention: null,
  timeSeries: {},
  isTimeSeriesLoading: false,
  chartId: '',
  newBins: false
}

const getters = {
  getTimeSeries: state => {
    return state.timeSeries
  },
  isTimeSeriesLoading: state => {
    return state.isTimeSeriesLoading
  },
  labelIndexs: state => {
    return state.labelIndexs
  }
}

const actions = {
  async getScansList (context, payload) {
    if (!payload.organization_id) return
    context.commit('SET_SCANS_LOADING', true)
    let response
    try {
      response = await api().get(`${URL}?organization_id=${payload.organization_id}`)
      if (response.data.length) {
        response.data.map(d => {
          if (d.scan_start_time != null) {
            const local = moment.utc(d.scan_start_time, 'YYYY-MM-DD HH:mm:ss').local()
            d.scan_start_time = moment(local, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm:ss A')
          } else { d.scan_start_time = '' }
        })
      }
      context.commit('SET_SCAN_LIST', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    context.commit('SET_SCANS_LOADING', false)
    return response.data
  },

  async getAnalysis (context, payload) {
    if (!payload.organization_id || !payload.discovery_id) return
    context.commit('SET_ANALYSIS_LOADING', true)
    const qPayload = router.currentRoute.query
    const age = qPayload.age ? qPayload.age.split(',') : []
    const size = qPayload.size ? qPayload.size.split(',') : []
    const file_extension = qPayload.file_extension ? (typeof qPayload.file_extension === 'string' ? qPayload.file_extension.split(',') : qPayload.file_extension) : []

    delete qPayload.start_datetime
    delete qPayload.end_datetime
    if (age.length) {
      qPayload.age = age.map(a => parseInt(a, 10))
    }
    if (file_extension.length) {
      qPayload.file_extension = file_extension
    }
    if (size.length) {
      qPayload.size = size.map(a => parseInt(a, 10))
    }
    qPayload.filterLabels = {}
    qPayload.filterLabels.age = age.map(index => labels2[index])
    qPayload.filterLabels.size = size.map(index => state.newBins ? newSizes[index] : sizes[index])
    qPayload.filterLabels.file_extension = file_extension
    const keys = Object.keys(qPayload)
    if (keys.includes('organization_id')) {
      context.dispatch('filterDiscoveryBars', { payload: qPayload, redirect: true })
      return
    }
    let response
    try {
      const drives = payload.drives.join(',')
      response = await api().get(`${URL_ANALYSIS}?organization_id=${payload.organization_id}&discovery_id=${payload.discovery_id}${drives.length ? '&drive=' + drives : ''}`)
      context.commit('SET_ANALYSIS', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    context.commit('SET_ANALYSIS_LOADING', false)
  },

  async getAnalysisByStartEndTime (context, payload) {
    if (!payload.start_datetime || !payload.end_datetime || !payload.organization_id) return
    if (payload.start_datetime && (payload.start_datetime == 'Invalid date' || payload.end_datetime == 'Invalid date')) {
      payload.start_datetime = moment().subtract('24', 'hours').format('X')
      payload.end_datetime = moment().format('X')
    }
    context.commit('SET_ANALYSIS_LOADING', true)
    const qPayload = router.currentRoute.query
    const age = qPayload.age ? (typeof qPayload.age === 'string' ? qPayload.age.split(',') : qPayload.age) : []
    const size = qPayload.size ? (typeof qPayload.age === 'string' ? qPayload.size.split(',') : qPayload.size) : []
    const file_extension = qPayload.file_extension ? (typeof qPayload.file_extension === 'string' ? qPayload.file_extension.split(',') : qPayload.file_extension) : []

    delete qPayload.discovery_id
    qPayload.start_datetime = payload.start_datetime
    qPayload.end_datetime = payload.end_datetime
    if (age.length) {
      qPayload.age = age.map(a => parseInt(a, 10))
    }
    if (file_extension.length) {
      qPayload.file_extension = file_extension
    }
    if (size.length) {
      qPayload.size = size.map(a => parseInt(a, 10))
    }
    qPayload.filterLabels = {}
    qPayload.filterLabels.age = age.map(index => labels2[index])
    qPayload.filterLabels.size = size.map(index => state.newBins ? newSizes[index] : sizes[index])
    qPayload.filterLabels.file_extension = file_extension

    let response
    try {
      response = await api().get(`${URL_ANALYSIS}?organization_id=${payload.organization_id}&start_datetime=${payload.start_datetime}&end_datetime=${payload.end_datetime}`)
      if (response.data && JSON.stringify(response.data) !== '{}') {
        context.commit('SET_ANALYSIS', response.data)
      } else {
        context.commit('SET_ANALYSIS', { drive: [], extension: [], last_modified: [], size: [] })
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    context.commit('SET_ANALYSIS_LOADING', false)
  },

  async filterDiscoveryBars (context, { payload, redirect }) {
    if (!payload.organization_id || !(payload.discovery_id || payload.start_datetime)) return
    if (payload.start_datetime && (payload.start_datetime == 'Invalid date' || payload.end_datetime == 'Invalid date')) {
      payload.start_datetime = moment().subtract('24', 'hours').format('X')
      payload.end_datetime = moment().format('X')
    }

    // when loading a url with a size filter
    if (payload.filterLabels.size.length && payload.filterLabels.size.every(x => !x)) {
      response = await api().get(`${URL_ANALYSIS}?organization_id=${payload.organization_id}&discovery_id=${payload.discovery_id}`)
      payload.filterLabels = payload.filterLabels ?? {}
      payload.filterLabels.size = payload.size ? payload.size.map(db => response.data.size.find(x => x.db_group_value == db).label) : []
      context.commit('SET_ANALYSIS', {
        size: response.data.size,
        filterLabels: {
          size: payload.filterLabels.size
        }
      })
    }

    // when re-setting size as the main filter
    if (state.sizeFilters.length && !state.lastModifiedFilters.length && !state.extensionFilters.length && state.chartId && state.chartId != 'size') {
      response = await api().get(`${URL_ANALYSIS}?organization_id=${payload.organization_id}&discovery_id=${payload.discovery_id}`)
      payload.filterLabels = payload.filterLabels ?? {}
      payload.filterLabels.size = payload.size ? payload.size.map(db => response.data.size.find(x => x.db_group_value == db).label) : []
      context.commit('SET_ANALYSIS', {
        size: response.data.size,
        filterLabels: {
          size: payload.filterLabels.size
        }
      })
    }

    const keys = Object.keys(payload)
    let queryParams = ''
    keys.forEach((key, index) => {
      if (key && key !== 'filterLabels') {
        queryParams = queryParams.concat(keys.length - 1 != index ? `${key}=${payload[key].toString()}&` : `${key}=${payload[key].toString()}`)
      }
    })
    history.pushState(
      {},
      null,
      router.currentRoute.path +
        '?' + queryParams
    )
    context.commit('SET_ANALYSIS_LOADING', true)
    if (redirect) {
      context.commit('SET_FILTERS2', payload)
    } else {
      context.commit('SET_FILTERS', payload)
    }
    let response
    try {
      response = await api().get(`${URL_ANALYSIS}?${queryParams}`)
      if (response.data && JSON.stringify(response.data) !== '{}') {
        response.data.chartId = payload.chartId
        delete response.data[payload.chartId]
        context.commit('SET_ANALYSIS', response.data)
      } else {
        context.commit('SET_ANALYSIS', { drive: [], extension: [], last_modified: [], size: [] })
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }

    context.commit('SET_ANALYSIS_LOADING', false)
  },
  async getComparison (context, payload) {
    if (!payload.organization_id || !payload.compareId || !payload.compareToId) return
    context.commit('SET_COMPARISON_LOADING', true)
    let response
    try {
      response = await api().get(`${URL_COMPARISON}?organization_id=${payload.organization_id}&compare_id=${payload.compareId}&compare_to_id=${payload.compareToId}`)
      context.commit('SET_COMPARISON', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    context.commit('SET_COMPARISON_LOADING', false)
  },
  async timeSeries (context, payload) {
    context.commit('SET_TIME_SERIES_LOADING', true)
    let response
    try {
      if (payload.collectors) {
        response = await api().post(`${URL_TIME_SERIES}?organization_id=${payload.organization_id}`, { ...payload })
      } else {
        response = await api().get(`${URL_TIME_SERIES}?organization_id=${payload.organization_id}`)
      }
      !payload.stateless && context.commit('SET_TIME_SERIES', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }

    context.commit('SET_TIME_SERIES_LOADING', false)
    return response
  }
}

const mutations = {
  SET_SIZE (state, data) {
    state.size = data
  },
  SET_LAST_MODIFIED (state, data) {
    state.last_modified = data
  },
  SET_EXTENSION (state, data) {
    state.extension = data
  },
  RESET_DISCOVERY_DATA (state) {
    state.size = []
    state.last_modified = []
    state.extension = []
    state.timeSeries = {}
  },
  SET_SCANS_LOADING (state, status) {
    state.isLoadingScans = status
  },
  SET_ANALYSIS_LOADING (state, status) {
    state.isLoadingAnalysis = status
  },
  SET_SCAN_LIST (state, data) {
    state.scanList = data
  },
  SET_ANALYSIS (state, data) {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (key === 'size') {
          let sortSize = []
          const filteredSizes = data.size.filter(size => size.db_group_value >= 0 && size.db_group_value < 7)

          if (Array.isArray(filteredSizes) && filteredSizes.length) {
            sortSize = addMissingBins(sizes, data.size, 0)
            state.newBins = false
          } else {
            sortSize = addMissingBins(newSizes, data.size, 7)
            state.newBins = true
          }

          state[key] = sortArrayWithString(sortSize, 'db_group_value')
        } else if (key === 'last_modified') {
          const sortAges = addMissingBins(ageBins, data[key], 0, true)
          state[key] = sortArrayWithString(sortAges, 'db_group_value')
        } else {
          state[key] = data[key]
        }
      }
    }

    const labelsMap = new Map()
    labelsMap.set('< 1yr old', '< 1')
    labelsMap.set('>= 1 and < 2 yrs', '1 - 2')
    labelsMap.set('>= 2 and < 3 yrs', '2 - 3')
    labelsMap.set('>= 3 and < 4 yrs', '3 - 4')
    labelsMap.set('>= 4 and < 5 yrs', '4 - 5')
    labelsMap.set('>= 5 and < 6 yrs', '5 - 6')
    labelsMap.set('>= 6 and < 7 yrs', '6 - 7')
    labelsMap.set('>= 7 and < 8 yrs', '7 - 8')
    labelsMap.set('>= 8 and < 9 yrs', '8 - 9')
    labelsMap.set('>= 9 and < 10 yrs', '9 - 10')
    labelsMap.set('>= 10yrs', '> 10')

    if (Object.keys(state.labelIndexs.size).length === 0) {
      const sortedSize = sortArrayWithString(data.size, 'db_group_value')
      // state.labelIndexs.size = state.size.map(s => s.label)
      // state.labelIndexs.size = sizes
      const lookup = {}
      sortedSize.forEach(s => {
        lookup[s.label] = s.db_group_value
      })

      state.labelIndexs.size = lookup
    }
    if (state.labelIndexs.age.length === 0) {
      state.labelIndexs.age = Array.from(labelsMap.values())
    }
  },
  SET_COMPARISON (state, data) {
    state.comparisonList = data
  },
  SET_COMPARISON_LOADING (state, status) {
    state.isLoadingComparison = status
  },
  SET_TIME_SERIES (state, data) {
    state.timeSeries = data
  },
  SET_TIME_SERIES_LOADING (state, status) {
    state.isTimeSeriesLoading = status
  },
  SET_FILTERS (state, data) {
    if (data.chartId === 'extension') {
      state.extensionFilters = !data.filterLabels.file_extension || [...data.filterLabels.file_extension]
    } else if (data.chartId === 'last_modified') {
      state.lastModifiedFilters = !data.filterLabels.age || [...data.filterLabels.age]
    } else if (data.chartId === 'size') {
      state.sizeFilters = !data.filterLabels.size || [...data.filterLabels.size]
    } else {
      state.extensionFilters = []
      state.lastModifiedFilters = []
      state.sizeFilters = []
    }
  },
  SET_FILTERS2 (state, data) {
    if (data.discovery_id) {
      state.discoveryId = data.discovery_id
    }
    if (data.age) {
      state.selectedAge = data.age
    }
    if (data.size) {
      state.selectedSize = data.size
    }
    if (data.file_extension) {
      state.selectedFileExtention = data.file_extension
    }
    if (data.filterLabels.file_extension) {
      state.extensionFilters = [...data.filterLabels.file_extension]
    }
    if (data.filterLabels.size) {
      state.sizeFilters = [...data.filterLabels.size]
    }
    if (data.filterLabels.age) {
      state.lastModifiedFilters = [...data.filterLabels.age]
    }
  },

  resetFilters (state, data) {
    const index = state[data.field].indexOf(data.value)
    state[data.field].splice(index, 1)
  },
  resetAllFilters (state) {
    state.sizeFilters = []
    state.lastModifiedFilters = []
    state.extensionFilters = []
    state.selectedFileExtention = []
    state.selectedAge = []
    state.selectedSize = []
  },
  resetAnalysis (state) {
    state.last_modified = []
    state.extension = []
    state.scanList = []
  },
  setFilterSunburst (state, payload) {
    state.lastModifiedFilters = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  name: 'discoveryServices'
}
